import _ from 'lodash';
export class Activicty {
  constructor() {
    this.action = '';
    this.activity = '';
    this.date = '';
    this.log_name = '';
    this.ip = '';
    // return this;
  }

  toListView(data) {
    return data.map(function (item) {
      return {
        id: item.id,
        action: item.action,
        activity: _.startCase(item.activity),
        date: item.date,
        log_name: item.log_name,
        ip: item.ip,
        icon:
          item.action == 'Created'
            ? 'mdi-heart'
            : item.action == 'Updated'
              ? 'mdi-pencil-box-outline'
              : 'mdi-archive',
        color:
          item.action == 'Created'
            ? 'green'
            : item.action == 'Updated'
              ? 'blue'
              : 'red',
      };
    });
  }
}
